import { BatteryModel } from 'src/Libs/batteries/models'

/**
 * Returns a new BatteryModel, out of 2 provided BatteryModels.
 *
 * @param next
 * @param previous
 */
export const mergeBatteries = (next: BatteryModel, previous: BatteryModel): BatteryModel => {
  return {
    batteryListIndex: next.batteryListIndex || previous.batteryListIndex,
    voltageAdjustment: next.voltageAdjustment || previous.voltageAdjustment,
    deviceState: next.deviceState || previous.deviceState,
    voltage: next.voltage || previous.voltage,
    dcbType: next.dcbType || previous.dcbType,
    terminalVoltage: next.terminalVoltage || previous.terminalVoltage,
    temperature: next.temperature || previous.temperature,
    current: next.current || previous.current,
    statusCode: next.statusCode || previous.statusCode,
    maxDischargeCurrent: next.maxDischargeCurrent || previous.maxDischargeCurrent,
    maxChargeCurrent: next.maxChargeCurrent || previous.maxChargeCurrent,
    eodVoltage: next.eodVoltage || previous.eodVoltage,
    cellVoltage: next.cellVoltage || previous.cellVoltage,
    maxVoltage: next.maxVoltage || previous.maxVoltage,
    errorCode: next.errorCode || previous.errorCode,
    chargeCycles: next.chargeCycles || previous.chargeCycles,
    firmwareVersion: next.firmwareVersion || previous.firmwareVersion,
    deviceName: next.deviceName || previous.deviceName,
    rsoc: next.rsoc || previous.rsoc,
    asoc: next.asoc || previous.asoc,
    countModules: next.countModules || previous.countModules,
    capacityRemaining: next.capacityRemaining || previous.capacityRemaining,
    capacityTotal: next.capacityTotal || previous.capacityTotal,
    paramBatNumber: next.paramBatNumber || previous.paramBatNumber,
  }
}
